import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Facility',
  description: 'Facility involved in any step of the blood donation workflow',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    name: types.STRING_INDEX,
    details: types.STRING,

    category: types.OBJECT,
    type: types.OBJECT,
    bloodBank: types.OBJECT,
    stockUnit: types.OBJECT,

    address: types.STRING,
    city: types.STRING,
    latitude: types.STRING, // float parsed as string
    longitude: types.STRING, // float parsed as string
    capacity: types.NUMBER,

    acceptsDeliveries: types.BOOLEAN, // Destinations
    acceptsPatients: types.BOOLEAN, // Hospital
    collectsBlood: types.BOOLEAN, // Blood donation center
    processesBlood: types.BOOLEAN, // Blood processing center
    requiresBlood: types.BOOLEAN, // Hospital
    storesBlood: types.BOOLEAN, // HQ Stock Unit
    suppliesBlood: types.BOOLEAN, // Blood bank
    testsBlood: types.BOOLEAN, // Laboratory

    // Audit fields
    ...auditFields
  },

  required: ['id', 'name'],
  indexes: [
    ['name']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
